import React, { Component } from 'react'
import { connect } from 'react-redux';
import classes from './VideoPlayerControls.module.scss';
import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';
import * as actions from 'store/actions/index';
import FlexRow from 'Flow2/components/UI/Container/FlexRow';
import FlexColumn from 'Flow2/components/UI/Container/FlexColumn';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCut, faStepForward, faStepBackward, faFileAlt, faForward, faBackward } from '@fortawesome/free-solid-svg-icons';
import { injectIntl } from 'react-intl';
import ClipUtil from 'Flow2/util/Clip';
import Overlay from 'Flow2/components/UI/Overlay/Overlay';
import * as OverlaySize from 'Flow2/components/UI/Overlay/Overlay';
import PH from 'Flow2/util/MetadataPermissionHelper.js';
import * as metadata from 'Flow2/containers/Masterdata/Masterdata';
import * as Controls from 'Flow2/config/Controls';



import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";
import {
	isVifogra, isFrancetv, refreshCurrentData, updateHistoryData
} from 'Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil';


import Swal from 'sweetalert2';

const mapStateToProps = (state, ownProps) => {
	return {
		user: state.auth.user,
		isGrabbingMainThumb: state.clip.isGrabbingMainThumb,
		config: state.ui.config,
		customHistory: state.customData.customHistory
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		grabMainThumb: (clipId, frame, width, height) => dispatch(actions.grabMainThumb(clipId, frame, width, height)),
		updateMetadata: (type, id, metadata) => dispatch(actions.updateMetadata(type, id, metadata)),
		setCustomHistory: (currentHistory) => dispatch(actions.setCustomHistory(currentHistory))
	}
}

const allowGrab = (props) => {
    if(PH.hasPermission({ user: props.user, originalObject: props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP })) {
        return true;
    }
    
    return PH.hasFieldPermission({ user: props.user, originalObject: props.clip.originalObject, type: metadata.OBJECT_TYPE_CLIP }, "*", "grab");
}

const grab = (props) => {
    if(!allowGrab(props) || !PH.showControl(props.config, Controls.CTL_PLAYER_THUMB)) return "";

	const onGrab = props.onGrabThumbnail || onGrabThumbnail;

	return (
		<div className={[classes.GrabThumb, classes.Icon, 'pointer'].join(' ')} >
			<FontAwesomeIcon onClick={() => onGrab(props)} icon="image" title={props.intl.formatMessage({ id: "videoplayer.thumbnail.grab" })} />
		</div>
	);
}

export const GrabThumbnail = connect(mapStateToProps, mapDispatchToProps)(injectIntl(grab));

export const onGrabThumbnail = (props) => {
    console.log(props.video.currentTime);
    const frame = (Number.isInteger(props.video.currentTime) && props.video.currentTime + ".0") || props.video.currentTime;
	//const frame = props.video.currentTime;//Math.floor(props.video.currentTime * props.mediafile.fps);
	const width = props.mediafile.width;
	const height = props.mediafile.height;

	Swal.fire({
		title: props.intl.formatMessage({ id: "popup.title.thumbnail.grab" }),
		text: props.intl.formatMessage({ id: "popup.message.thumbnail.grab" }),
		showCancelButton: false,
		confirmButtonText: props.intl.formatMessage({ id: "common.ok" }),
		confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
		buttonsStyling: false
	}).then((result) => {
		if (result.value) {
			props.grabMainThumb(props.clip.id, frame, width, height);

			props.afterOnGrabThumbnail && props.afterOnGrabThumbnail(props);
			//HISTORY BEGIN
			if (isFrancetv() && props.clip.id) {
				let updatedHistory = updateHistoryData(props.user.id, CustomTypes.MASTER_THUMB_VIDEO);
				let currentData = refreshCurrentData(props.customHistory.showHistory, updatedHistory);
				if (updatedHistory) props.updateMetadata("clip", props.clip.id, { history: updatedHistory });
				if (currentData) props.setCustomHistory({ showHistory: { ...currentData } });
			}
			//HISTORY END
		}
	})
}
